'use strict';

var _require = require('./Component'),
    CopyToClipboard = _require.CopyToClipboard;

module.exports = CopyToClipboard;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-copy-to-clipboard/lib/index.js
// module id = 1221
// module chunks = 0 3 5